<template>
<SendTable opt-type="20,30"></SendTable>
</template>

<script>
import SendTable from '@/views/modules/erp/company/client/send-table.vue'
export default {
  components: { SendTable },
  data () {
    return {}
  },
  methods: {
    beforeTableBinding (dataList) {
    },
  },
}
</script>

<style lang="scss" scoped>

</style>


